<template>
  <div>
    <div class="p-bottom-15">
      <customer-contact
        :customer="customerInfo"
        :contact-data="contactData"
        :invoice-id="invoiceId"
        :booking-info="bookingInfo"
        :item-id="itemId"
        :item-type="itemType"
        :estimate-id="estimateId"
        :has-estimate="hasEstimate"
        :from-view-page="fromViewPage"
        :customer-trading-name="customerTradingName"
        :unique-id="customer.customer_id"
        :labels="customerLabels"
        action-name="customerSelectLabel"
        list-container="span"
        :base-url="baseUrl"
        :all-labels="allLabels"
        :line-address="lineAddress"
        :logged-user-role="loggedUserRole"
        :for-customer-only="forCustomerOnly"
        :showAddress="showAddress"
        :business-type="companyObject.business_type"
        :customer-data="customer"
        :is-australia="isAustralia"
        :customer-notes="customer_notes"
        :can-add-customer-note="canAddCustomerNote"
        :customer-attributes="customerAttributes"
        :country-code="countryCode"
        :date-format="JsDateFormat"
        :properties="properties"
        :country-key="countryKey"
        :inquiry-has-booking="inquiryHasBooking"
        :inquiry-booking-id="inquiryBookingId"
      >
      </customer-contact>
    </div>
    <confirmation-popup
      title="Notice"
      message="Would you like to Change Booking Location to the new customer location or keep current ? "
      confirm-btn-text="Change"
      cancel-btn-text="Keep Current"
      @on-confirm="ChangeBookingLocation"
      id="ask_change_loaction_because_of_changing_customer"
    >
    </confirmation-popup>
    <change-customer-popup
      :customer="customer"
      :event="event"
      :counter="counter"
      :can-add-customer="canAddCustomer"
      :can-edit-customer="canEditCustomer"
      :selected-customer-id="customer.customer_id"
    >
    </change-customer-popup>
  </div>
</template>

<script>
import CustomerDetailsModal from "@/modules/Customer/components/CustomerDetailsModal.vue";
import {
  changeBookingLocationApi,
  initalizeCustomerInfoComponent,
} from "@/modules/Customer/api";
import moment from "moment/moment";
import { EventBus } from "@/events/event-bus";
import CustomerContact from "./CustomerContact.vue";
import ConfirmationPopup from "../../common/components/ConfirmationPopup.vue";
import ChangeCustomerPopup from "../../Booking/components/ChangeCustomerPopup.vue";
export default {
  name: "CustomerInfo",
  components: {
    ChangeCustomerPopup,
    ConfirmationPopup,
    CustomerContact,
    CustomerDetailsModal,
  },
  props: {
    itemType: {
      type: String,
      default: "booking",
    },
    customerId: {
      required: true,
    },
    itemId: null,
    estimateId: null,
    hasEstimate: 0,
    invoiceId: "",
    counter: 1,
    fromViewPage: {
      default() {
        return false;
      },
    },
    inquiryHasBooking: 0,
    inquiryBookingId: 0,
    customerSigned: null,
    customerSignatureId: null,
    showAddress: true,
    signatureLink: "",
    event: null,
    allLabels: null,
  },
  data() {
    return {
      customer: {},
      oldCustomerid: null,
      bookingInfo: {},
      customerTradingName: "",
      changedItemCustomer: false,
      customer_notes: {},
      countryCode: "",
      JsDateFormat: "",
      countryKey: "",
      invoiceID: "",
      customerInfo: [],
      forCustomerOnly: Boolean,
      loggedUserRole: "admin",
      companyObject: {},
      lineAddress: "",
      canAddCustomerNote: false,
      contactData: [],
      credentials: [],
      customerAttributes: null,
      customerLabels: null,
      properties: null,
      baseUrl: "",
      isSectionCollapsed: this.fromViewPage,
      isAustralia: false,
      isUserMobile: false,
      canAddCustomer: false,
      canEditCustomer: false,
      activeTab: 1,
    };
  },
  computed: {
    propertiesEncoded() {
      return btoa(JSON.stringify(this.properties));
    },
    isMobile() {
      return this.getWidth() <= 768;
    },
  },
  methods: {
    getWidth() {
      let xWidth = null;
      if (window.screen != null) xWidth = window.screen.availWidth;

      if (window.innerWidth != null) xWidth = window.innerWidth;

      if (document.body != null) xWidth = document.body.clientWidth;

      return xWidth;
    },
    confirmDelete() {},
    initalizeCustomerInfoComponent() {
      let params = {
        customer_id: this.customerId,
        item_id: this.itemId,
        show_address: this.showAddress,
        item_type: this.itemType,
        change_item_customer: this.changedItemCustomer,
        old_customer_id: this.oldCustomerid,
      };
      initalizeCustomerInfoComponent(params).then((response) => {
        this.changedItemCustomer = false;
        this.customer = response.data.customer;
        this.customer_notes = response.data.customer_notes;
        this.countryCode = response.data.country_code;
        this.countryKey = response.data.country_key;
        this.customerTradingName = response.data.customerTradingName;
        this.JsDateFormat = response.data.JsDateFormat;
        this.customerInfo = response.data.customerInfo;
        this.loggedUserRole = response.data.loggedUser;
        this.lineAddress = response.data.line_address;
        this.canAddCustomerNote = response.data.AddCustomerNote;
        this.contactData = response.data.contactData;
        this.credentials = response.data.credentials;
        this.customerAttributes = response.data.customerAttributes;
        this.customerLabels = response.data.customerLabels;
        this.properties = response.data.customerProperties;
        (this.baseUrl = response.data.base_url),
          (this.isAustralia = response.data.isAustralia),
          (this.canEditCustomer = response.data.canEditCustomer),
          (this.canAddCustomer = response.data.canAddCustomer),
          (this.isUserMobile = response.data.isUserMobile);
        EventBus.$emit(
          "onCustomerUpdated",
          this.customerInfo,
          this.contactData
        );
      });
    },

    ChangeBookingLocation() {
      changeBookingLocationApi(
        this.customer.customer_id,
        this.itemId,
        this.itemType
      ).then((responseData) => {
        if (responseData.data.status === "success") {
          if (this.counter === 1) {
            EventBus.$emit(
              "bookingAddressesChanged",
              responseData.data.bookingAddresses
            );
            EventBus.$emit("onCustomerChanged", this.customer);
            EventBus.$emit("oncustomerChangedFromViewBooking", this.customer);
          }
          $.notify("Address updated successfully", "success");
        } else {
          $.notify("Failed to update address", "error");
        }
      });
    },
  },
  mounted() {
    EventBus.$on("openContactDetailsModal", (id) => {
      $(`#customerDetailsModal${id}`).modal("show");
    });

    EventBus.$on("newCustomerAdded", () => {
      this.initalizeCustomerInfoComponent();
    });

    EventBus.$on(
      "customerChangedFromViewBooking",
      (customer, selectedCustomerId = 0) => {
        if (selectedCustomerId == this.customerId) {
          /**  to confirm that is the customer that selected   **/
          this.changedItemCustomer = true;
          this.oldCustomerid = this.customerId;
          this.customerId = customer.customer_id;
          this.initalizeCustomerInfoComponent();
          $("#ask_change_loaction_because_of_changing_customer").modal("show");
        }
      }
    );
    this.initalizeCustomerInfoComponent();
  },
};
</script>
<style scoped>
/* Define the transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.customer-details-section-title {
  color: var(--Navy, #2e4051);
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
.border-style {
  border-radius: 12px;
}
@media (max-width: 768px) {
  #customer-info-block {
    /*padding: 15px 18px 0px;*/
  }
  .padding-15-18 {
    padding: 15px 18px 0px;
  }
  .no-padding-bottom {
    margin-bottom: 25px;
  }
}
</style>
